import { HttpClient, JSON_STRING, MHTTPCL } from "../../../services/http/http-client";
import { SETTINGS_URL } from "../../../services/common-urls";

export const UserService = {
  findUserList: ({
    user_name,
    password
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'authenticate',
    redirect_to: 'SetUserSetupTab',
    output: JSON_STRING,
    user_name,
    password,
  }),
  findUserSetup: ({
    user_id
  }, options) => HttpClient.get(SETTINGS_URL, {
    section: 'usersetup',
    action: 'user_detail',
    user_id
  }, options),
  findUserModules: ({
    user_id
  }, options) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'hide_module_sections',
    get_tree_json: true,
    perm_user_id: user_id
  }, options),
  saveHiddenModule: ({
    items,
    user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'hide_module_sections',
    container: 'all',
    perm_sec: 'blocked',
    items_arr: 'yes',
    reset_container: 'yes',
    items,
    perm_user_id: user_id,
  }),
  findUnhiddenInvoiceProjects: ({
    user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'invoice_projects',
    output: JSON_STRING,
    user_id,
  }),
  hideInvoiceProjects: ({
    items,
    perm_user_id,
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'hide_module_sections',
    container: 'invoice_projects',
    perm_sec: 'blocked',
    items_arr: 'yes',
    reset_container: '',
    items,
    perm_user_id,
  }),
  fetchHiddenInvoiceProjects: ({
    user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'add_project_permission',
    output: JSON_STRING,
    user_id
  }),
  unhideInvoiceProject: ({
    invoice_project_id,
    user_id,
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'delete_invoice_project',
    invoice_project_id,
    user_id,
  }),
  findUnhiddenArtists: ({
    user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'artists',
    output: JSON_STRING,
    user_id
  }),
  hideArtistFees: ({
    items,
    perm_user_id,
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'hide_module_sections',
    container: 'booking_artists',
    perm_sec: 'blocked',
    items_arr: 'yes',
    reset_container: '',
    items,
    perm_user_id,
  }),
  fetchHiddenArtistsFees: ({
    user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'add_artist_permission',
    output: JSON_STRING,
    user_id,
  }),
  unHideArtistsFees: ({
    user_id,
    artist_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'delete_artist',
    user_id,
    artist_id
  }),
  insertNewuser: ({
    user_name,
    password,
    staff_email,
    language,
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'save_user',
    output: JSON_STRING,
    user_name,
    password,
    staff_email,
    language,
  }),
  insertExternalUser: ({
    user_name,
    email,
    language,
    given_name,
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'add_external_user',
    user_name,
    email,
    language,
    given_name
  }),
  removeUser: ({
    user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'delete_user',
    user_id
  }),
  removeExternalUserPermission: ({
    external_users_permission_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'delete_external_user_permission',
    external_users_permission_id
  }),
  removeExternalUsers: ({
    external_user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'delete_external_user',
    external_user_id
  }),

  postHideModuleSection: (items, perm_user_id) => MHTTPCL.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'hide_module_sections',
    items: items,
    container: 'roles',
    perm_sec: 'allowed',
    perm_user_id: perm_user_id,
    items_arr: 'yes',
    reset_container: 'yes'

  }),
  findExternalUserDetails: ({
    external_user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'ext_user_detail',
    external_user_id,
    output: JSON_STRING,
  }),
  getAllExternalUsers: () => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'all_ext_users',
    output: JSON_STRING,
  }),
  searchExternalUsers: (search_term) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'search_ext_users',
    search_term:search_term,
    output: JSON_STRING,
  }),
  loadRoyaltyStatementPermissions: ({
    external_user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'load_royalty_statement_permissions',
    external_user_id,
    output: JSON_STRING,
  }),
  openRoyaltyStatementPermissionModal: ({
    external_user_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'open_royalty_statement_permission_modal',
    external_user_id,
    output: JSON_STRING,
  }),
  searchRoyaltyAccountOfExt_user: ({
    external_user_id,
    search_txt,
    invoice_project_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'search_royalty_account_of_ext_user',
    external_user_id,
    search_txt,
    invoice_project_id,
    output: JSON_STRING,
  }),
  addExternalUserPermission: ({
    external_user_id,
    external_ids
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'ext_user_setup',
    action: 'add_external_user_permission',
    module: 'royalty_account',
    external_table: 'royalty_statement',
    external_user_id,
    external_ids,
    output: JSON_STRING,
  }),

}